module.exports = __webpack_public_path__ + "img/advantage_img.4461b536.jpg";